import { useTranslation } from "react-i18next";

import { NewsDto } from "../..";
import Dialog from "../../../../../../components/Dialog/Dialog";
import { DialogHeight } from "../../../../../../components/Dialog/types/enums";
import { useMediaQueries } from "../../../../../../shared";
import CloseDialogButton from "../../components/CloseDialogButton";
import { NEWS_DIALOG_SIZES } from "../../types/enums";

import ReleaseNotesDialogContent from "./components/ReleaseNotesDialogContent";

interface ReleaseNotesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  newsData: NewsDto | null;
  isLoading: boolean;
}

const ReleaseNotesDialog = ({
  isOpen,
  onClose,
  newsData,
  isLoading
}: ReleaseNotesDialogProps) => {
  const { toMd } = useMediaQueries();
  const { t } = useTranslation();

  return (
    <Dialog
      data-testid="release-notes-dialog"
      isTitleSeparator
      title={t("Dialog##release notes")}
      isActionsSeparator
      actions={<CloseDialogButton onClose={onClose} isLoading={false} />}
      open={isOpen}
      close={onClose}
      width={NEWS_DIALOG_SIZES.width}
      extendToMaxWidth={toMd}
      maxHeight={DialogHeight.MaxHeight}
    >
      <ReleaseNotesDialogContent isLoading={isLoading} newsData={newsData} />
    </Dialog>
  );
};

export default ReleaseNotesDialog;
